import React, { forwardRef } from 'react';
import cx from 'classnames';

export const Company = forwardRef((
    { children, className, style },
    ref
) => (
    <span style={style} ref={ref} className={cx('typo typo--avatar-company', className)}>
        {children}
    </span>
));

export const Thread = forwardRef((
    { children, className, style },
    ref
) => (
    <span style={style} ref={ref} className={cx('typo typo--avatar-threads', className)}>
        {children}
    </span>
));

export const Message = forwardRef((
    { children, className, style },
    ref
) => (
    <span style={style} ref={ref} className={cx('typo typo--avatar-messages', className)}>
        {children}
    </span>
));

